import type { Messages } from "./en";

export const zhHans: Messages = {
  meta: {
    pageTitle: "{{page}} - Calendar App",
    appName: "日历应用",
  },
  nav: {
    appTitle: "日历应用",
    home: "首页",
    records: "记录",
    dashboard: "仪表盘",
    admin: "管理",
    adminWithPage: "管理-{{page}}",
    users: "用户",
    cron: "定时任务",
    trash: "回收站",
    settings: "设置",
    logout: "退出",
    language: "语言",
    record: "记录",
    calendar: "日历",
    place: "地点",
    resetPassword: "重置密码",
  },
  common: {
    save: "保存",
    saveChanges: "保存更改",
    cancel: "取消",
    close: "关闭",
    confirm: "确认",
    delete: "删除",
    add: "新增",
    edit: "编辑",
    view: "查看",
    search: "搜索",
    map: "地图",
    submit: "提交",
    reset: "重置",
    run: "运行",
    restore: "恢复",
    loading: "加载中…",
    pleaseSelect: "请选择",
    invalidDate: "日期无效",
    notAvailable: "不适用",
    warning: "警告：",
    showHide: "显示/隐藏",
    unableToLoadData: "无法加载数据。",
    pleaseEnterValidField: "请输入有效的{{field}}！",
    pleaseEnterTheField: "请输入［{{field}}］！",
  },
  fields: {
    password: "密码",
    confirmPassword: "确认密码",
    confirmPasswordSentence: "确认密码",
    currentPassword: "当前密码",
    newPassword: "新密码",
    newPasswordSentence: "新密码",
    email: "电子邮件",
    emailAddress: "电子邮箱",
    id: "编号",
    username: "用户名",
    role: "角色",
    name: "名称",
    title: "标题",
    description: "说明",
    address: "地址",
    color: "颜色",
    calendar: "日历",
    calendars: "日历",
    place: "地点",
    record: "记录",
    startDate: "开始日期",
    endDate: "结束日期",
    start: "开始",
    end: "结束",
    prefix: "前缀",
    created: "创建时间",
    lastUpdated: "最后更新",
    defaultShow: "默认显示",
    calendarName: "日历名称",
    placeName: "地点名称",
    recordType: "记录类型",
    action: "操作",
    selectCalendars: "选择日历",
  },
  login: {
    title: "登录",
    login: "登录",
    passwordEmpty: "请输入密码。",
    passwordIncorrect: "密码错误。请重试，或点击“忘记密码”进行重置。",
    emailInvalid: "请输入有效的电子邮件。",
    forgotPassword: "忘记密码？",
    forgotPasswordTitle: "忘记密码",
    submit: "登录",
    resetPassword: "重置密码",
    resetEmailSent: "重置密码邮件已成功发送。",
    resetEmailFailed: "无法发送重置密码邮件，请重试。",
  },
  reset: {
    title: "重置密码",
    passwordEmpty: "请输入密码。",
    unableToReset: "无法重置密码！",
    userNotFound: "找不到用户！",
    linkExpired: "重置链接已过期！请重新申请。",
    passwordsDoNotMatch: "两次输入的密码不一致！",
    invalidResetLink: "重置链接无效！",
    passwordResetSuccessful: "密码已成功重置！",
    submit: "提交",
    linkExpiredTitle: "链接已过期",
  },
  record: {
    createOneSuccess: "记录（{{id}}）已成功创建！",
    createManySuccess: "已成功创建 {{num}} 条记录！",
    createFailed: "无法创建新记录！",
    updateFailed: "无法更新记录（{{id}}）！",
    updateMultiFailed: "无法更新记录（{{ids}}）！",
    updateSuccess: "记录（{{id}}）已成功更新！",
    updateMultiSuccess: "记录（{{ids}}）已成功更新！",
    deleteFailed: "无法删除记录（{{id}}）！",
    deleteMultiFailed: "无法删除记录（{{ids}}）！",
    deleteSuccess: "记录（{{id}}）已删除！",
    deleteMultiSuccess: "记录（{{ids}}）已删除！",
    failedToLoad: "无法获取记录数据！",
    failedToFindId: "找不到记录编号！",
    idInvalid: "记录编号无效！",
    editMany: "编辑记录（{{count}}）",
    deleteMany: "删除记录（{{count}}）",
  },
  calendar: {
    createSuccess: "日历（{{name}}）已成功创建！",
    createFailed: "无法创建新日历！",
    updateFailed: "无法更新日历（{{name}}）！",
    updateSuccess: "日历（{{name}}）已成功更新！",
    deleteFailed: "无法删除日历（{{name}}）！",
    deleteSuccess: "日历（{{name}}）已删除！",
    failedToLoad: "无法获取日历数据！",
    nameInvalid: "日历名称（{{name}}）无效！",
    nameExists: "日历名称（{{name}}）已存在！",
    colorInvalid: "日历颜色无效！",
    add: "新增日历",
    edit: "编辑日历",
    menu: "日历",
    listTitle: "日历",
    noCalendars: "还没有日历！",
    selectCalendars: "选择日历",
    name: "名称",
    namePlaceholder: "日历名称",
    color: "颜色",
    defaultShow: "默认显示",
  },
  place: {
    createSuccess: "地点（{{name}}）已成功创建！",
    createFailed: "无法创建新地点！",
    updateFailed: "无法更新地点（{{name}}）！",
    updateSuccess: "地点（{{name}}）已成功更新！",
    deleteFailed: "无法删除地点（{{name}}）！",
    deleteSuccess: "地点（{{name}}）已删除！",
    failedToLoad: "无法获取地点数据！",
    nameInvalid: "地点名称（{{name}}）无效！",
    nameExists: "地点名称（{{name}}）已存在！",
    addressEmpty: "地点地址为空！",
    add: "新增地点",
    edit: "编辑地点",
    listTitle: "地点",
  },
  cron: {
    createSuccess: "定时任务（{{name}}）已成功创建！",
    createFailed: "无法创建新的定时任务！",
    updateFailed: "无法更新定时任务（{{id}}）！",
    updateSuccess: "定时任务（{{id}}）已成功更新！",
    deleteFailed: "无法删除定时任务（{{id}}）！",
    deleteSuccess: "定时任务（{{id}}）已删除！",
    failedToLoad: "无法获取地点数据！",
    invalid: "定时任务值无效！",
    exists: "定时任务（{{name}}）已存在！",
    runSuccess: "定时任务（{{name}}）已成功执行！",
    runFailed: "定时任务（{{name}}）执行失败！",
    addCronJob: "新增定时任务",
    editCronJob: "编辑定时任务",
  },
  calendarUi: {
    failedToFindEvent: "找不到活动（{{id}}）！",
    failedToGetApi: "找不到［calendarApi］！",
  },
  event: {
    add: "新增活动",
    edit: "编辑活动",
    deleteTitle: "删除活动",
    deleteConfirm: "确定要删除这个活动吗？",
    unableToGet: "无法获取活动数据！",
    copied: "活动（{{id}}）已复制！",
    copy: "复制活动",
    endBeforeStart: "结束日期必须晚于开始日期！",
    endDateInvalid: "请输入有效的结束日期！",
    endDateRequired: "请输入结束日期！",
    mapTitle: "地图 - {{name}}",
  },
  grid: {
    emptySelection: "请选择一条记录！",
    emptyData: "找不到记录！",
    doesNotIncludeRecord: "表格不包含记录（{{id}}）！",
    doesNotIncludeMultiRecord: "表格不包含记录（{{ids}}）！",
    failedToFindRowById: "找不到编号为（{{id}}）的记录！",
    pleaseSelectRecords: "请至少选择 1 条记录！",
    failedToRestore: "恢复（{{type}}）记录失败！",
    failedToDelete: "删除（{{type}}）记录失败！",
    restored: "已恢复 {{count}} 条（{{type}}）记录！",
    deleted: "已删除 {{count}} 条（{{type}}）记录！",
    copiedToClipboard: "已复制到剪贴板！",
    paginationNext: "下一页",
    paginationPrevious: "上一页",
  },
  settings: {
    title: "设置",
    password: "密码",
    passwordEmpty: "请输入密码。",
    passwordIncorrect: "旧密码不正确！",
    confirmPasswordNotMatch: "密码不一致！",
    updateSuccess: "密码已更新！",
    userDetailNotFound: "找不到用户资料！",
    keepCurrentPassword: "留空则保留当前密码",
  },
  user: {
    failedToLoad: "无法获取用户数据！",
    usernameEmpty: "请输入用户名。",
    passwordEmpty: "请输入密码。",
    passwordMismatch: "密码不一致。",
    createSuccess: "用户已创建。",
    createFailed: "无法创建用户。",
    updateSuccess: "用户已更新。",
    updateFailed: "无法更新用户。",
    deleteSuccess: "用户已删除。",
    deleteFailed: "无法删除用户。",
    cannotDeleteSelf: "无法删除当前登录的用户。",
    selectOne: "请选择一个用户。",
    addUser: "新增用户",
    editUser: "编辑用户",
    deleteTitle: "删除用户",
    deleteWarning:
      "此操作会永久删除该用户。如果用户仍有地点或记录，则无法删除。",
  },
  dashboard: {
    title: "仪表盘",
    fetchFailed: "无法获取仪表盘数据。",
    nextEvents: "即将到来的活动",
    prevEvents: "先前的活动",
    upcomingEvents: "即将到来的活动",
    nextHoliday: "下一个假期",
    noHoliday: "没有假期…",
    monthEvents: "本月活动数",
    monthlySummary: "{{year}} 每月汇总",
    eventDistribution: "{{year}} 活动分布",
    totalEventDistribution: "活动总分布",
    events: "活动",
  },
};
